import React from 'react';

const SvgTg = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="TG_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="TG_svg__b" fill="#fff">
        <use xlinkHref="#TG_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#TG_svg__a" />
      <path fill="#FFD44D" mask="url(#TG_svg__b)" d="M0 0h28v20H0z" />
      <path
        d="M12 0h16v4H12V0zm0 8h16v4H12V8zM0 16h28v4H0v-4z"
        fill="#159A74"
        mask="url(#TG_svg__b)"
      />
      <path fill="#ED1F45" mask="url(#TG_svg__b)" d="M0 0h12v12H0z" />
      <path
        fill="#FFF"
        mask="url(#TG_svg__b)"
        d="M6 7.56L3.649 9.236l.867-2.754-2.32-1.718 2.887-.026L6 2l.917 2.738 2.887.026-2.32 1.718.867 2.754z"
      />
    </g>
  </svg>
);

export default SvgTg;
